// Traduzioni del sito Ncc Bologna — lingua base: italiano (it)
export const LANGS = [
  { code: "it", label: "Italiano", short: "IT" },
  { code: "en", label: "English", short: "EN" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "de", label: "Deutsch", short: "DE" },
  { code: "es", label: "Español", short: "ES" },
];

export const translations = {
  it: {
    nav: { servizi: "Servizi", flotta: "Flotta", contatti: "Contatti", preventivo: "Preventivo" },
    hero: {
      overline: "Ncc Bologna · Noleggio Con Conducente",
      title1: "Transfer",
      title2: "di Lusso",
      taglinePre: "Nel caos del traffico quotidiano, garantiamo un transfer ",
      taglineBold: "affidabile, puntuale e di lusso",
      taglinePost: ".",
      ctaBook: "Prenota il tuo transfer",
      ctaFleet: "La nostra flotta",
      f1: "Conducenti professionisti",
      f2: "Puntualità garantita",
      f3: "Servizio su misura",
    },
    services: {
      overline: "Cosa offriamo",
      title: "I Nostri Servizi",
      items: [
        { title: "Transfer Aeroporti e Stazioni", desc: "Trasferimenti puntuali da e per aeroporti e stazioni, con monitoraggio del volo e accoglienza dedicata." },
        { title: "Motor Valley Tour", desc: "Esperienze esclusive nei musei Ferrari, Lamborghini e Pagani. Il cuore della terra dei motori." },
        { title: "Shopping Tour", desc: "Tour dedicati tra le migliori boutique e outlet della regione." },
        { title: "Tour Gastronomici", desc: "Alla scoperta dei sapori dell'Emilia: tortellini, mortadella, Parmigiano e aceto balsamico, con guida disponibile nella tua lingua." },
        { title: "Transfer su Misura per Eventi", desc: "Spostamenti personalizzati per business, meeting, cerimonie ed eventi privati." },
      ],
    },
    fleet: {
      overline: "Vetture a disposizione",
      title: "La Nostra Flotta",
      subtitle: "Una gamma selezionata di vetture premium, sempre impeccabili, per ogni esigenza di viaggio.",
      items: [
        { variant: "Berlina & Station Wagon", note: "L'eleganza per transfer business e privati.", seats: "4 passeggeri", luggage: "3 – 4 valigie" },
        { variant: "Station Wagon", note: "Comfort sportivo e ampio bagagliaio.", seats: "4 passeggeri", luggage: "4 valigie" },
        { variant: "Minivan", note: "Ideale per gruppi, famiglie e tour.", seats: "Fino a 7 passeggeri", luggage: "7+ valigie" },
      ],
    },
    slideshow: {
      overline: "Bologna, la nostra città",
      labels: ["Le Due Torri", "Piazza Maggiore", "Il Centro Storico", "I Portici", "I Tetti di Bologna"],
    },
    reviews: {
      overline: "Dicono di noi",
      title: "Recensioni",
      subtitle: "La fiducia dei nostri clienti è il nostro biglietto da visita migliore.",
      items: [
        { name: "Marco Bianchi", location: "Bologna", role: "Transfer Aeroporto", text: "Puntualità impeccabile per il transfer dall'aeroporto. Auto elegante e autista professionale. Consigliatissimo." },
        { name: "Sophie Laurent", location: "Lione", role: "Motor Valley Tour", text: "Tour in Motor Valley organizzato alla perfezione. Un'esperienza di lusso dall'inizio alla fine." },
        { name: "Andrea Rossi", location: "Milano", role: "Transfer Eventi", text: "Servizio raffinato e discreto per un evento aziendale. Mezzi impeccabili e massima cortesia." },
        { name: "Julia Meyer", location: "Monaco", role: "Tour Gastronomico", text: "Viaggio comodissimo con la Classe V per tutta la famiglia. Autista gentile e disponibile." },
      ],
    },
    whatsapp: { label: "Scrivici su WhatsApp", message: "Salve! Vorrei informazioni per un transfer con Bologna NCC." },
    form: {
      overline: "Prenota ora",
      title: "Richiedi un Preventivo",
      subtitle: "Compila il modulo: riceverai una proposta personalizzata per il tuo transfer.",
      name: "Nome", namePh: "Mario Rossi",
      phone: "Telefono", phonePh: "+39 333 1234567",
      vehicle: "Veicolo preferito", vehiclePh: "Seleziona un veicolo",
      email: "Email", date: "Data prevista", time: "Ora prevista", service: "Servizio", description: "Descrizione",
      emailPh: "latua@email.com",
      descPh: "Indica partenza, destinazione, numero di passeggeri ed eventuali richieste.",
      servicePh: "Seleziona un servizio",
      submit: "Invia richiesta", submitting: "Invio in corso...",
      options: ["Transfer Aeroportuale", "Transfer Stazione", "Shopping Tour", "Motor Valley Tour", "Tour Gastronomico", "Evento / Cerimonia", "Servizio su Misura"],
      toastSuccessTitle: "Richiesta inviata!", toastSuccessDesc: "Ti contatteremo al più presto con il tuo preventivo.",
      toastErrTitle: "Errore nell'invio", toastErrDesc: "Si è verificato un problema. Riprova più tardi.",
    },
    footer: {
      desc: "Servizio di noleggio con conducente. Transfer di lusso, affidabili e puntuali.",
      serviziHeading: "Servizi",
      serviziList: ["Transfer Aeroporti e Stazioni", "Motor Valley Tour", "Shopping Tour", "Tour Gastronomici", "Transfer su Misura per Eventi"],
      contattiHeading: "Contatti", area: "Bologna e Provincia", rights: "Tutti i diritti riservati", slogan: "Transfer di Lusso · Bologna",
    },
  },

  en: {
    nav: { servizi: "Services", flotta: "Fleet", contatti: "Contact", preventivo: "Get a Quote" },
    hero: {
      overline: "Ncc Bologna · Chauffeur Service",
      title1: "Luxury",
      title2: "Transfer",
      taglinePre: "In the chaos of daily traffic, we guarantee a ",
      taglineBold: "reliable, punctual and luxurious",
      taglinePost: " transfer.",
      ctaBook: "Book your transfer",
      ctaFleet: "Our fleet",
      f1: "Professional chauffeurs",
      f2: "Guaranteed punctuality",
      f3: "Tailored service",
    },
    services: {
      overline: "What we offer",
      title: "Our Services",
      items: [
        { title: "Airport & Station Transfers", desc: "Punctual transfers to and from airports and stations, with flight monitoring and a dedicated welcome." },
        { title: "Motor Valley Tour", desc: "Exclusive experiences at the Ferrari, Lamborghini and Pagani museums. The heart of the land of motors." },
        { title: "Shopping Tour", desc: "Dedicated tours among the region's finest boutiques and outlets." },
        { title: "Food & Wine Tours", desc: "Discover the flavours of Emilia: tortellini, mortadella, Parmigiano and balsamic vinegar, with a guide available in your language." },
        { title: "Bespoke & Event Transfers", desc: "Personalized transfers for business, meetings, ceremonies and private events." },
      ],
    },
    fleet: {
      overline: "Available vehicles",
      title: "Our Fleet",
      subtitle: "A selected range of premium vehicles, always impeccable, for every travel need.",
      items: [
        { variant: "Sedan & Station Wagon", note: "Elegance for business and private transfers.", seats: "4 passengers", luggage: "3 – 4 suitcases" },
        { variant: "Station Wagon", note: "Sporty comfort and a spacious boot.", seats: "4 passengers", luggage: "4 suitcases" },
        { variant: "Minivan", note: "Ideal for groups, families and tours.", seats: "Up to 7 passengers", luggage: "7+ suitcases" },
      ],
    },
    slideshow: {
      overline: "Bologna, our city",
      labels: ["The Two Towers", "Piazza Maggiore", "The Old Town", "The Porticoes", "The Rooftops of Bologna"],
    },
    reviews: {
      overline: "What they say",
      title: "Reviews",
      subtitle: "Our clients' trust is our finest calling card.",
      items: [
        { name: "Marco Bianchi", location: "Bologna", role: "Airport Transfer", text: "Impeccable punctuality for the airport transfer. Elegant car and professional chauffeur. Highly recommended." },
        { name: "Sophie Laurent", location: "Lyon", role: "Motor Valley Tour", text: "A perfectly organized Motor Valley tour. A luxury experience from start to finish." },
        { name: "Andrea Rossi", location: "Milan", role: "Event Transfer", text: "Refined and discreet service for a corporate event. Impeccable vehicles and the utmost courtesy." },
        { name: "Julia Meyer", location: "Munich", role: "Food & Wine Tour", text: "A very comfortable trip with the V-Class for the whole family. Kind and helpful chauffeur." },
      ],
    },
    whatsapp: { label: "Chat on WhatsApp", message: "Hello! I'd like information about a transfer with Bologna NCC." },
    form: {
      overline: "Book now",
      title: "Request a Quote",
      subtitle: "Fill out the form: you'll receive a personalized proposal for your transfer.",
      name: "Name", namePh: "John Smith",
      phone: "Phone", phonePh: "+39 333 1234567",
      vehicle: "Preferred vehicle", vehiclePh: "Select a vehicle",
      email: "Email", date: "Expected date", time: "Expected time", service: "Service", description: "Description",
      emailPh: "you@email.com",
      descPh: "Enter pick-up, destination, number of passengers and any requests.",
      servicePh: "Select a service",
      submit: "Send request", submitting: "Sending...",
      options: ["Airport Transfer", "Station Transfer", "Shopping Tour", "Motor Valley Tour", "Food & Wine Tour", "Event / Ceremony", "Bespoke Service"],
      toastSuccessTitle: "Request sent!", toastSuccessDesc: "We'll contact you as soon as possible with your quote.",
      toastErrTitle: "Sending error", toastErrDesc: "Something went wrong. Please try again later.",
    },
    footer: {
      desc: "Chauffeur service (NCC). Luxury, reliable and punctual transfers.",
      serviziHeading: "Services",
      serviziList: ["Airport & Station Transfers", "Motor Valley Tour", "Shopping Tour", "Food & Wine Tours", "Bespoke & Event Transfers"],
      contattiHeading: "Contact", area: "Bologna and Province", rights: "All rights reserved", slogan: "Luxury Transfer · Bologna",
    },
  },

  fr: {
    nav: { servizi: "Services", flotta: "Flotte", contatti: "Contact", preventivo: "Devis" },
    hero: {
      overline: "Ncc Bologna · Service de chauffeur",
      title1: "Transfert",
      title2: "de Luxe",
      taglinePre: "Dans le chaos de la circulation quotidienne, nous garantissons un transfert ",
      taglineBold: "fiable, ponctuel et luxueux",
      taglinePost: ".",
      ctaBook: "Réservez votre transfert",
      ctaFleet: "Notre flotte",
      f1: "Chauffeurs professionnels",
      f2: "Ponctualité garantie",
      f3: "Service sur mesure",
    },
    services: {
      overline: "Ce que nous offrons",
      title: "Nos Services",
      items: [
        { title: "Transferts Aéroports et Gares", desc: "Transferts ponctuels depuis et vers les aéroports et les gares, avec suivi des vols et accueil dédié." },
        { title: "Motor Valley Tour", desc: "Expériences exclusives dans les musées Ferrari, Lamborghini et Pagani. Le cœur de la terre des moteurs." },
        { title: "Shopping Tour", desc: "Circuits dédiés parmi les meilleures boutiques et outlets de la région." },
        { title: "Tours Gastronomiques", desc: "À la découverte des saveurs de l'Émilie : tortellini, mortadelle, Parmesan et vinaigre balsamique, avec un guide disponible dans votre langue." },
        { title: "Transferts sur Mesure et Événements", desc: "Transferts personnalisés pour affaires, réunions, cérémonies et événements privés." },
      ],
    },
    fleet: {
      overline: "Véhicules disponibles",
      title: "Notre Flotte",
      subtitle: "Une gamme sélectionnée de véhicules premium, toujours impeccables, pour tous vos besoins de déplacement.",
      items: [
        { variant: "Berline & Break", note: "L'élégance pour les transferts d'affaires et privés.", seats: "4 passagers", luggage: "3 – 4 valises" },
        { variant: "Break", note: "Confort sportif et coffre spacieux.", seats: "4 passagers", luggage: "4 valises" },
        { variant: "Minivan", note: "Idéal pour groupes, familles et excursions.", seats: "Jusqu'à 7 passagers", luggage: "7+ valises" },
      ],
    },
    slideshow: {
      overline: "Bologne, notre ville",
      labels: ["Les Deux Tours", "Piazza Maggiore", "Le Centre Historique", "Les Portiques", "Les Toits de Bologne"],
    },
    reviews: {
      overline: "Ils parlent de nous",
      title: "Avis",
      subtitle: "La confiance de nos clients est notre meilleure carte de visite.",
      items: [
        { name: "Marco Bianchi", location: "Bologne", role: "Transfert Aéroport", text: "Ponctualité impeccable pour le transfert depuis l'aéroport. Voiture élégante et chauffeur professionnel. Vivement recommandé." },
        { name: "Sophie Laurent", location: "Lyon", role: "Motor Valley Tour", text: "Un tour de la Motor Valley parfaitement organisé. Une expérience de luxe du début à la fin." },
        { name: "Andrea Rossi", location: "Milan", role: "Transfert Événements", text: "Service raffiné et discret pour un événement d'entreprise. Véhicules impeccables et grande courtoisie." },
        { name: "Julia Meyer", location: "Munich", role: "Tour Gastronomique", text: "Voyage très confortable avec la Classe V pour toute la famille. Chauffeur aimable et disponible." },
      ],
    },
    whatsapp: { label: "Écrivez-nous sur WhatsApp", message: "Bonjour ! Je souhaite des informations pour un transfert avec Bologna NCC." },
    form: {
      overline: "Réservez",
      title: "Demandez un Devis",
      subtitle: "Remplissez le formulaire : vous recevrez une proposition personnalisée pour votre transfert.",
      name: "Nom", namePh: "Jean Dupont",
      phone: "Téléphone", phonePh: "+39 333 1234567",
      vehicle: "Véhicule préféré", vehiclePh: "Sélectionnez un véhicule",
      email: "Email", date: "Date prévue", time: "Heure prévue", service: "Service", description: "Description",
      emailPh: "vous@email.com",
      descPh: "Indiquez le départ, la destination, le nombre de passagers et vos demandes.",
      servicePh: "Sélectionnez un service",
      submit: "Envoyer la demande", submitting: "Envoi en cours...",
      options: ["Transfert Aéroport", "Transfert Gare", "Shopping Tour", "Motor Valley Tour", "Tour Gastronomique", "Événement / Cérémonie", "Service sur Mesure"],
      toastSuccessTitle: "Demande envoyée !", toastSuccessDesc: "Nous vous contacterons au plus vite avec votre devis.",
      toastErrTitle: "Erreur d'envoi", toastErrDesc: "Un problème est survenu. Veuillez réessayer plus tard.",
    },
    footer: {
      desc: "Service de location avec chauffeur (NCC). Transferts de luxe, fiables et ponctuels.",
      serviziHeading: "Services",
      serviziList: ["Transferts Aéroports et Gares", "Motor Valley Tour", "Shopping Tour", "Tours Gastronomiques", "Transferts sur Mesure et Événements"],
      contattiHeading: "Contact", area: "Bologne et Province", rights: "Tous droits réservés", slogan: "Transfert de Luxe · Bologne",
    },
  },

  de: {
    nav: { servizi: "Leistungen", flotta: "Flotte", contatti: "Kontakt", preventivo: "Angebot" },
    hero: {
      overline: "Ncc Bologna · Chauffeurservice",
      title1: "Luxus",
      title2: "Transfer",
      taglinePre: "Im Chaos des täglichen Verkehrs garantieren wir einen ",
      taglineBold: "zuverlässigen, pünktlichen und luxuriösen",
      taglinePost: " Transfer.",
      ctaBook: "Transfer buchen",
      ctaFleet: "Unsere Flotte",
      f1: "Professionelle Chauffeure",
      f2: "Garantierte Pünktlichkeit",
      f3: "Maßgeschneiderter Service",
    },
    services: {
      overline: "Unser Angebot",
      title: "Unsere Leistungen",
      items: [
        { title: "Flughafen- und Bahnhofstransfers", desc: "Pünktliche Transfers von und zu Flughäfen und Bahnhöfen, mit Flugüberwachung und persönlichem Empfang." },
        { title: "Motor Valley Tour", desc: "Exklusive Erlebnisse in den Museen von Ferrari, Lamborghini und Pagani. Das Herz des Motorenlandes." },
        { title: "Shopping Tour", desc: "Spezielle Touren zu den besten Boutiquen und Outlets der Region." },
        { title: "Gastronomische Touren", desc: "Entdecken Sie die Aromen der Emilia: Tortellini, Mortadella, Parmesan und Balsamico-Essig, mit einem Guide in Ihrer Sprache." },
        { title: "Maßgeschneiderte Transfers und Events", desc: "Individuelle Transfers für Business, Meetings, Zeremonien und private Events." },
      ],
    },
    fleet: {
      overline: "Verfügbare Fahrzeuge",
      title: "Unsere Flotte",
      subtitle: "Eine ausgewählte Palette an Premium-Fahrzeugen, stets makellos, für jeden Reisebedarf.",
      items: [
        { variant: "Limousine & Kombi", note: "Eleganz für Business- und Privattransfers.", seats: "4 Passagiere", luggage: "3 – 4 Koffer" },
        { variant: "Kombi", note: "Sportlicher Komfort und großer Kofferraum.", seats: "4 Passagiere", luggage: "4 Koffer" },
        { variant: "Minivan", note: "Ideal für Gruppen, Familien und Touren.", seats: "Bis zu 7 Passagiere", luggage: "7+ Koffer" },
      ],
    },
    slideshow: {
      overline: "Bologna, unsere Stadt",
      labels: ["Die Zwei Türme", "Piazza Maggiore", "Die Altstadt", "Die Arkaden", "Die Dächer von Bologna"],
    },
    reviews: {
      overline: "Das sagen sie",
      title: "Bewertungen",
      subtitle: "Das Vertrauen unserer Kunden ist unsere beste Visitenkarte.",
      items: [
        { name: "Marco Bianchi", location: "Bologna", role: "Flughafentransfer", text: "Tadellose Pünktlichkeit beim Flughafentransfer. Elegantes Auto und professioneller Chauffeur. Sehr empfehlenswert." },
        { name: "Sophie Laurent", location: "Lyon", role: "Motor Valley Tour", text: "Eine perfekt organisierte Motor-Valley-Tour. Ein Luxuserlebnis von Anfang bis Ende." },
        { name: "Andrea Rossi", location: "Mailand", role: "Event-Transfer", text: "Erstklassiger und diskreter Service für ein Firmenevent. Makellose Fahrzeuge und höchste Zuvorkommenheit." },
        { name: "Julia Meyer", location: "München", role: "Gastronomische Tour", text: "Sehr komfortable Fahrt mit der V-Klasse für die ganze Familie. Freundlicher und hilfsbereiter Chauffeur." },
      ],
    },
    whatsapp: { label: "WhatsApp-Chat", message: "Hallo! Ich hätte gerne Informationen zu einem Transfer mit Bologna NCC." },
    form: {
      overline: "Jetzt buchen",
      title: "Angebot Anfordern",
      subtitle: "Füllen Sie das Formular aus: Sie erhalten ein individuelles Angebot für Ihren Transfer.",
      name: "Name", namePh: "Max Mustermann",
      phone: "Telefon", phonePh: "+39 333 1234567",
      vehicle: "Bevorzugtes Fahrzeug", vehiclePh: "Fahrzeug auswählen",
      email: "E-Mail", date: "Wunschdatum", time: "Wunschuhrzeit", service: "Leistung", description: "Beschreibung",
      emailPh: "sie@email.com",
      descPh: "Geben Sie Abfahrt, Ziel, Anzahl der Passagiere und Wünsche an.",
      servicePh: "Leistung auswählen",
      submit: "Anfrage senden", submitting: "Wird gesendet...",
      options: ["Flughafentransfer", "Bahnhofstransfer", "Shopping Tour", "Motor Valley Tour", "Gastronomische Tour", "Event / Zeremonie", "Individueller Service"],
      toastSuccessTitle: "Anfrage gesendet!", toastSuccessDesc: "Wir kontaktieren Sie schnellstmöglich mit Ihrem Angebot.",
      toastErrTitle: "Fehler beim Senden", toastErrDesc: "Es ist ein Problem aufgetreten. Bitte versuchen Sie es später erneut.",
    },
    footer: {
      desc: "Chauffeurservice (NCC). Luxuriöse, zuverlässige und pünktliche Transfers.",
      serviziHeading: "Leistungen",
      serviziList: ["Flughafen- und Bahnhofstransfers", "Motor Valley Tour", "Shopping Tour", "Gastronomische Touren", "Maßgeschneiderte Transfers und Events"],
      contattiHeading: "Kontakt", area: "Bologna und Provinz", rights: "Alle Rechte vorbehalten", slogan: "Luxus-Transfer · Bologna",
    },
  },

  es: {
    nav: { servizi: "Servicios", flotta: "Flota", contatti: "Contacto", preventivo: "Presupuesto" },
    hero: {
      overline: "Ncc Bologna · Servicio de chófer",
      title1: "Transfer",
      title2: "de Lujo",
      taglinePre: "En el caos del tráfico diario, garantizamos un transfer ",
      taglineBold: "fiable, puntual y de lujo",
      taglinePost: ".",
      ctaBook: "Reserva tu transfer",
      ctaFleet: "Nuestra flota",
      f1: "Chóferes profesionales",
      f2: "Puntualidad garantizada",
      f3: "Servicio a medida",
    },
    services: {
      overline: "Lo que ofrecemos",
      title: "Nuestros Servicios",
      items: [
        { title: "Transfers Aeropuertos y Estaciones", desc: "Traslados puntuales desde y hacia aeropuertos y estaciones, con seguimiento de vuelos y recepción dedicada." },
        { title: "Motor Valley Tour", desc: "Experiencias exclusivas en los museos Ferrari, Lamborghini y Pagani. El corazón de la tierra de los motores." },
        { title: "Shopping Tour", desc: "Tours dedicados entre las mejores boutiques y outlets de la región." },
        { title: "Tours Gastronómicos", desc: "Descubre los sabores de Emilia: tortellini, mortadela, Parmesano y vinagre balsámico, con guía disponible en tu idioma." },
        { title: "Transfers a Medida y Eventos", desc: "Traslados personalizados para negocios, reuniones, ceremonias y eventos privados." },
      ],
    },
    fleet: {
      overline: "Vehículos disponibles",
      title: "Nuestra Flota",
      subtitle: "Una gama seleccionada de vehículos premium, siempre impecables, para cada necesidad de viaje.",
      items: [
        { variant: "Berlina & Familiar", note: "La elegancia para transfers de negocios y privados.", seats: "4 pasajeros", luggage: "3 – 4 maletas" },
        { variant: "Familiar", note: "Confort deportivo y amplio maletero.", seats: "4 pasajeros", luggage: "4 maletas" },
        { variant: "Minivan", note: "Ideal para grupos, familias y tours.", seats: "Hasta 7 pasajeros", luggage: "7+ maletas" },
      ],
    },
    slideshow: {
      overline: "Bolonia, nuestra ciudad",
      labels: ["Las Dos Torres", "Piazza Maggiore", "El Casco Antiguo", "Los Pórticos", "Los Tejados de Bolonia"],
    },
    reviews: {
      overline: "Lo que dicen",
      title: "Opiniones",
      subtitle: "La confianza de nuestros clientes es nuestra mejor tarjeta de presentación.",
      items: [
        { name: "Marco Bianchi", location: "Bolonia", role: "Transfer Aeropuerto", text: "Puntualidad impecable en el transfer desde el aeropuerto. Coche elegante y chófer profesional. Muy recomendable." },
        { name: "Sophie Laurent", location: "Lyon", role: "Motor Valley Tour", text: "Un tour por Motor Valley perfectamente organizado. Una experiencia de lujo de principio a fin." },
        { name: "Andrea Rossi", location: "Milán", role: "Transfer Eventos", text: "Servicio refinado y discreto para un evento de empresa. Vehículos impecables y máxima cortesía." },
        { name: "Julia Meyer", location: "Múnich", role: "Tour Gastronómico", text: "Viaje muy cómodo con la Clase V para toda la familia. Chófer amable y atento." },
      ],
    },
    whatsapp: { label: "Escríbenos por WhatsApp", message: "¡Hola! Quisiera información para un transfer con Bologna NCC." },
    form: {
      overline: "Reserva ahora",
      title: "Solicita un Presupuesto",
      subtitle: "Rellena el formulario: recibirás una propuesta personalizada para tu transfer.",
      name: "Nombre", namePh: "Juan Pérez",
      phone: "Teléfono", phonePh: "+39 333 1234567",
      vehicle: "Vehículo preferido", vehiclePh: "Selecciona un vehículo",
      email: "Email", date: "Fecha prevista", time: "Hora prevista", service: "Servicio", description: "Descripción",
      emailPh: "tu@email.com",
      descPh: "Indica salida, destino, número de pasajeros y cualquier petición.",
      servicePh: "Selecciona un servicio",
      submit: "Enviar solicitud", submitting: "Enviando...",
      options: ["Transfer Aeropuerto", "Transfer Estación", "Shopping Tour", "Motor Valley Tour", "Tour Gastronómico", "Evento / Ceremonia", "Servicio a Medida"],
      toastSuccessTitle: "¡Solicitud enviada!", toastSuccessDesc: "Te contactaremos lo antes posible con tu presupuesto.",
      toastErrTitle: "Error al enviar", toastErrDesc: "Ha ocurrido un problema. Inténtalo de nuevo más tarde.",
    },
    footer: {
      desc: "Servicio de alquiler con conductor (NCC). Transfers de lujo, fiables y puntuales.",
      serviziHeading: "Servicios",
      serviziList: ["Transfers Aeropuertos y Estaciones", "Motor Valley Tour", "Shopping Tour", "Tours Gastronómicos", "Transfers a Medida y Eventos"],
      contattiHeading: "Contacto", area: "Bolonia y Provincia", rights: "Todos los derechos reservados", slogan: "Transfer de Lujo · Bolonia",
    },
  },
};
